<div class="SubMenuContent" [class.opened]="menuOpened">
  @if (isPerm2D) {
    <ins-expansion-box [leftPositionedArrow]="true" [titleHeight]="'auto'"
      [elementOnPanel]="false"  [titleStyle]="{'padding': '6px 0 6px 2px', 'align-items': 'flex-end', 'line-height': '20px'}">
      <div titleContent style="white-space: normal">2D Model</div>
      <div content class="subSubMenuEntries">
        @if (isPerm2DUpload) {
          <div id="upload2DModelLink" (click)="uploadLayout()">&nbsp; Upload</div>
        }
        @if (isPerm2DEdit) {
          <div (click)="editLayout()">&nbsp; Edit</div>
        }
        @if (isPerm2DDelete) {
          <div (click)="deleteLayouts()">&nbsp; Delete</div>
        }
      </div>
    </ins-expansion-box>
  }
  @if (!(limitedAccess$ | async).disable3DModels && isPerm3D) {
    <ins-expansion-box [leftPositionedArrow]="true" [titleHeight]="'auto'"
      [elementOnPanel]="false" [titleStyle]="{'padding': '6px 0 6px 2px', 'align-items': 'flex-end', 'line-height': '20px'}">
      <div titleContent style="white-space: normal">3D Model</div>
      <div content class="subSubMenuEntries">
        @if (isPerm3DUpload) {
          <div id="upload3DModelLink" (click)="uploadModel()">&nbsp; Upload</div>
        }
        @if (isPerm3DEdit) {
          <div (click)="editModel()">&nbsp; Edit</div>
        }
        @if (isPerm3DDelete) {
          <div (click)="deleteModel()">&nbsp; Delete</div>
        }
      </div>
    </ins-expansion-box>
  }
</div>
@if (isPermModel) {
  <div id="modelMenuBtn" class="SubMenuButton" [class.pressed]="menuOpened" (click)="toggleMenu()">
    @if (visible) {
      <mat-icon class="subMenuArrow" svgIcon="arrow.submenu"></mat-icon>
    }
    <mat-icon class="subMenuIcon" [class.pressed]="menuOpened" svgIcon="models.submenu"></mat-icon>
    <div>Model</div>
  </div>
}
